export default {
  title: 'Registration',

  namePH: 'Name',
  nameTaken: 'This name is already taken',
  nameErr: 'Your name may only contain letters and digits',

  emailPH: 'Email',
  emailTaken: 'This email is already taken',
  emailErr: 'This email is invalid',

  pwd1PH: 'Password',
  pwd2PH: 'Repeat password',
  pwdErr: 'The passwords must match',

  profilePic: 'Avatar',

  formErr: 'Please review your inputs for errors',
  submit: 'Register',
  busy: 'Please Wait',
  success: 'Your registration was successful! Proceed to the login',
  fail: 'Something went wrong - please try again later'
}



// WEBPACK FOOTER //
// ./src/i18n/register/en.js